import { Lock, Check, ArrowRight } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "@/components/primitives/button";

interface Props {
  onSubscribe: () => void;
}

const PERK_KEYS = [
  "payments.gate.perk1",
  "payments.gate.perk2",
  "payments.gate.perk3",
] as const;

export default function NoSubscriptionGate({ onSubscribe }: Props) {
  const { t } = useTranslation();

  return (
    <div className="relative flex min-h-full items-center justify-center px-5 py-12">
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(circle at 50% 30%, hsl(var(--secondary) / 0.10), transparent 60%)",
        }}
      />
      <div className="relative w-full max-w-[460px] rounded-[14px] border border-border bg-card px-6 py-8 text-center">
        <div className="mx-auto mb-3.5 flex size-12 items-center justify-center rounded-xl bg-secondary/10 text-secondary">
          <Lock size={22} />
        </div>
        <p className="mb-2 text-[10.5px] font-bold uppercase tracking-[0.16em] text-secondary">
          {t("payments.gate.eyebrow")}
        </p>
        <h2 className="mb-2.5 text-[18px] font-semibold leading-snug tracking-tight">
          {t("payments.gate.title")}
        </h2>
        <p className="mx-auto mb-5 max-w-sm text-[13px] leading-relaxed text-muted-foreground">
          {t("payments.gate.body")}
        </p>
        <div className="mb-6 flex flex-col gap-2.5 rounded-[10px] border border-border/70 bg-muted/40 px-4 py-3.5 text-left">
          {PERK_KEYS.map((key, i) => (
            <div
              key={i}
              className="flex items-center gap-2.5 text-[13px] text-foreground/90"
            >
              <Check
                size={14}
                className="shrink-0"
                style={{ color: "hsl(142 65% 55%)" }}
              />
              <span>
                <Trans
                  i18nKey={key}
                  t={t}
                  components={{ strong: <strong className="font-semibold" /> }}
                />
              </span>
            </div>
          ))}
        </div>
        <Button
          onClick={onSubscribe}
          className="h-11 w-full gap-2 text-[15px] font-semibold"
        >
          {t("payments.gate.choosePlan")}
          <ArrowRight size={16} />
        </Button>
      </div>
    </div>
  );
}
